import { createContext, useContext } from "react";

const MountThirdwebContext = createContext({
  thirdwebUIReady: false,
  requestMountThirdweb: () => Promise.resolve(),
});

export function useMountThirdweb() {
  return useContext(MountThirdwebContext).thirdwebUIReady;
}

/** Call before opening the wallet UI so ThirdwebProvider loads even on deferred routes. */
export function useRequestMountThirdweb() {
  return useContext(MountThirdwebContext).requestMountThirdweb;
}

export { MountThirdwebContext };
